import React, { useState } from "react";
import IconContainer from "./IconContainer";

const AppButton = ({ children, ...props }) => {
	let {
		onClick,
		variant,
		label,
		minimize,
		id,
		tabIndex,
		// onKeyPress,
		onFocus,
		onKeyDown,
		color,
		minContent,
		lang,
		selectedType,
		isActionElement = false,
		style,
		classNameChildren
	} = props;

	let actionPadding = isActionElement ? "0px 5px 0px 5px" : "0px 10px 0px 10px"
	const [hover, setHover] = useState(false);

	if (typeof variant === "undefined")
		variant = "basic";

	const classes = {
		button: {
			cursor: "pointer",
			height: (props.id === "languages" ? "fit-content" : "auto"),
		},
		disabled: {
			height: (props.id === "languages" ? "fit-content" : "auto"),
		},
		light: {
			paddingLeft: (props.paddingWidth ? props.paddingWidth + 'px' : 0),
			paddingRight: (props.paddingWidth ? props.paddingWidth + 'px' : 0),
			paddingTop: (props.padding ? props.padding + 'px' : 0),
			paddingBottom: (props.padding ? props.padding + 'px' : 0),
			width: (props.width ? props.width : ""),
			color: (props) => {
				switch (props.color) {
					case 'secondary':
						return "var(--red-color)"
					case 'info':
						return "#148be6"
					case 'violet':
						return "#a649f1"
					default:
						return "var(--dark-color)"
				}
			},
			border: "solid 1px",
			backgroundColor: "var(--white-color)",
			"&.selectedType": {
				backgroundColor: props.disabled ? "" : props.color === "secondary" ? "var(--red-color)" : props.color === "info" ? "#148be6" : props.color === "violet" ? "#a649f1" : "var(--dark-color)",
				color: (props.disabled ? "var(--red-color)" : "var(--white-color)"),
			},
		},
		outlined: {
			paddingLeft: (props.paddingWidth ? props.paddingWidth + 'px' : 0),
			paddingRight: (props.paddingWidth ? props.paddingWidth + 'px' : 0),
			paddingTop: (props.padding ? props.padding + 'px' : 0),
			paddingBottom: (props.padding ? props.padding + 'px' : 0),
			border: "dashed 4px",
			color: (props.color === "secondary" ? "var(--red-color)" : "var(--dark-color)"),
		},
		contained: {
			paddingLeft: (props.paddingWidth ? props.paddingWidth + 'px' : 0),
			paddingRight: (props.paddingWidth ? props.paddingWidth + 'px' : 0),
			paddingTop: (props.padding ? props.padding + 'px' : 0),
			paddingBottom: (props.padding ? props.padding + 'px' : 0),
			width: (props.width ? props.width : "unset"),
			color: (props.color === "secondary" ? "var(--white-color)" : "var(--white-color)"),
			border: (props.noBorder ? "solid 0px" : "solid 1px"),
			backgroundColor: props.color === "secondary" ? "var(--red-color)" : "var(--dark-color)",
		},
		basic: {
			paddingLeft: (props.paddingWidth ? props.paddingWidth + 'px' : 0),
			paddingRight: (props.paddingWidth ? props.paddingWidth + 'px' : 0),
			paddingTop: (props.padding ? props.padding + 'px' : 0),
			paddingBottom: (props.padding ? props.padding + 'px' : 0),
			color: (props.color === "secondary" ? "var(--red-color)" : "var(--dark-color)"),
		},
		minContent: {
			width: "80%",
		},
		buttonApp: {
			display: "flex",
			alignItems: "center",
			justifyContent: "center",
			padding: actionPadding,
		},
		impact: {
			backgroundColor: props.disabled ? "" : props.color === "secondary" ? "var(--red-color)" : props.color === "info" ? "#148be6" : props.color === "violet" ? "#a649f1" : "var(--dark-color)",
			color: (props.disabled ? "var(--red-color)" : "var(--white-color)"),
			textTransform: 'uppercase',
			paddingLeft: (props.paddingWidth ? props.paddingWidth + 'px' : 0),
			paddingRight: (props.paddingWidth ? props.paddingWidth + 'px' : 0),
			paddingTop: (props.padding ? props.padding + 'px' : 0),
			paddingBottom: (props.padding ? props.padding + 'px' : 0),
			width: (props.width ? props.width : "unset"),
			fontWeight: "900",
		}
	}

	const classesHover = {
		light: {
			backgroundColor: props.disabled ? "" : props.color === "secondary" ? "var(--red-color)" : props.color === "info" ? "#148be6" : props.color === "violet" ? "#a649f1" : "var(--dark-color)",
			color: (props.disabled ? "var(--red-color)" : "var(--white-color)"),
		},
		outlined: {
			color: (props.color === "secondary" ? "var(--dark-color)" : "var(--red-color)"),
		},
		contained: {
			border: '1px solid var(--red-color)',
			color: (props.color === "secondary" ? "var(--red-color)" : "var(--dark-color)"),
			backgroundColor: "var(--white-color)",
		},
		basic: {
			color: (props.color === "secondary" ? "var(--dark-color)" : "var(--red-color)"),
		},
		impact : {
			color: (props.color === "secondary" ? "var(--red-color)" : "var(--dark-color)"),
			backgroundColor: "var(--white-color)",
		}
	}

	let displayLang = ''
	if (lang) {
		displayLang = lang.toLowerCase()
	}

	const [leftIcon, setLeftIcon] = React.useState(props.leftIcon);
	const [rightIcon, setRightIcon] = React.useState(props.rightIcon);
	return (
		<button
			lang={displayLang}
			onMouseEnter={() => {
				setHover(true);
				if (props.leftIcon) {
					setLeftIcon(<IconContainer
						icon={props.leftIcon?.props?.icon === "ACCOUNT_RED" ? "ACCOUNT_WHITE" : props.leftIcon?.props?.icon}
						size={props.leftIcon?.props?.size}
						noHover
						color={variant === "light" ? "WHITE" : color === "primary" ? "BLACK" : "RED"}
					></IconContainer>);
				}
				if (props.rightIcon) {
					setRightIcon(<IconContainer
						icon={props.rightIcon?.props?.icon}
						size={props.rightIcon?.props?.size}
						noHover
						color={variant === "light" ? "WHITE" : color === "primary" ? "BLACK" : "RED"}
					></IconContainer>);
				}
			}}
			onMouseLeave={() => {
				setHover(false);
				if (leftIcon) setLeftIcon(props.leftIcon);
				if (rightIcon) setRightIcon(props.rightIcon);
			}}
			tabIndex={tabIndex}
			id={id}
			onClick={onClick}
			// onKeyDown={onKeyPress}
			onFocus={onFocus}
			onKeyDown={onKeyDown}
			aria-label={label}
			title={label}
			className={`${selectedType ? 'selectedType' : ''} `}
			style={{
				...classes.button,
				...classes[variant],
				...(hover ? classesHover[variant]: {}),
				...style,
			}}
		>
			<div
				style={{...classes.buttonApp}}
			>
				{leftIcon && 
				<div style={{ marginRight: 10 }}>
					{leftIcon}
				</div>}
				<div
					className={classNameChildren}
					style={{
						...(minContent ? classes.minContent : {}),
						...(minimize ? { textTransform: "capitalize"} : { textTransform: "uppercase"})
					}}
				>
					{children}
				</div>
				{rightIcon && (
				<div style={{ marginLeft: 10, border: "none" }}>
					{rightIcon}
				</div>)}
			</div>
		</button>
	);
};

export default AppButton;
